// extracted by mini-css-extract-plugin
module.exports = {"hidden":"Logo_hidden__syt6a","logo":"Logo_logo__5xyYV","image":"Logo_image__w0PMs","isFooter":"Logo_isFooter__02xOg"};